import React, { useEffect, useState } from "react";
import apiClient from "../../lib/api";
import { useI18n } from "../../i18n";
import { toast } from "sonner";
import { Plus, Trash2, Save } from "lucide-react";

const blank = { code: "", type: "percent", value: 10, min_subtotal: 0, active: true, description: "" };

const AdminDiscounts = () => {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [draft, setDraft] = useState(blank);

  const load = () => apiClient.get("/admin/discounts").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!draft.code) return;
    try {
      await apiClient.post("/admin/discounts", draft);
      setDraft(blank);
      load();
      toast.success(lang === "nl" ? "Aangemaakt" : "Created");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  const save = async (d) => {
    try {
      await apiClient.put(`/admin/discounts/${d.code}`, d);
      toast.success(lang === "nl" ? "Opgeslagen" : "Saved");
    } catch (e) { toast.error("Failed"); }
  };

  const remove = async (code) => {
    if (!window.confirm("Delete?")) return;
    await apiClient.delete(`/admin/discounts/${code}`);
    load();
  };

  const update = (idx, key, val) => {
    const c = [...items];
    c[idx] = { ...c[idx], [key]: val };
    setItems(c);
  };

  return (
    <div data-testid="admin-discounts-page">
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-light mb-8">{lang === "nl" ? "Kortingen" : "Discounts"}</h1>

      <div className="border border-black/10 bg-white p-6 mb-6">
        <div className="font-label text-ink-muted mb-3">{lang === "nl" ? "Nieuwe code" : "New code"}</div>
        <div className="grid grid-cols-6 gap-3 items-center">
          <input value={draft.code} onChange={(e) => setDraft({ ...draft, code: e.target.value.toUpperCase() })} placeholder="WELCOME10" className="border border-black/15 px-3 py-2 text-sm" data-testid="discount-code" />
          <select value={draft.type} onChange={(e) => setDraft({ ...draft, type: e.target.value })} className="border border-black/15 bg-white px-3 py-2 text-sm" data-testid="discount-type">
            <option value="percent">% percent</option>
            <option value="fixed">€ fixed</option>
          </select>
          <input type="number" value={draft.value} onChange={(e) => setDraft({ ...draft, value: parseFloat(e.target.value) })} placeholder="Value" className="border border-black/15 px-3 py-2 text-sm" data-testid="discount-value" />
          <input type="number" value={draft.min_subtotal} onChange={(e) => setDraft({ ...draft, min_subtotal: parseFloat(e.target.value) })} placeholder="Min €" className="border border-black/15 px-3 py-2 text-sm" data-testid="discount-min" />
          <input value={draft.description} onChange={(e) => setDraft({ ...draft, description: e.target.value })} placeholder="Description" className="border border-black/15 px-3 py-2 text-sm" data-testid="discount-desc" />
          <button onClick={create} className="btn-primary text-sm" data-testid="discount-create"><Plus className="w-4 h-4" /> Add</button>
        </div>
      </div>

      <div className="border border-black/10 bg-white divide-y divide-black/5">
        {items.map((d, i) => (
          <div key={d.code} className="p-4 grid grid-cols-12 gap-3 items-center" data-testid={`discount-row-${d.code}`}>
            <div className="col-span-2 font-mono text-xs">{d.code}</div>
            <select value={d.type} onChange={(e) => update(i, "type", e.target.value)} className="col-span-1 border border-black/15 bg-white px-2 py-1.5 text-sm">
              <option value="percent">%</option>
              <option value="fixed">€</option>
            </select>
            <input type="number" value={d.value} onChange={(e) => update(i, "value", parseFloat(e.target.value))} className="col-span-1 border border-black/15 px-2 py-1.5 text-sm" />
            <input type="number" value={d.min_subtotal} onChange={(e) => update(i, "min_subtotal", parseFloat(e.target.value))} className="col-span-1 border border-black/15 px-2 py-1.5 text-sm" />
            <input value={d.description} onChange={(e) => update(i, "description", e.target.value)} className="col-span-4 border border-black/15 px-2 py-1.5 text-sm" />
            <label className="col-span-1 text-xs flex items-center gap-1"><input type="checkbox" checked={!!d.active} onChange={(e) => update(i, "active", e.target.checked)} /> active</label>
            <div className="col-span-2 flex justify-end gap-1">
              <button onClick={() => save(d)} className="p-2 hover:bg-secondary-warm"><Save className="w-4 h-4" /></button>
              <button onClick={() => remove(d.code)} className="p-2 hover:bg-terracotta/10 text-terracotta"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDiscounts;
